import { connect } from 'react-redux'
import NavigationHelper from 'layers/navigation/navigationHelper'
import ContainedIconButton from './component'

export default connect(
  null,
  NavigationHelper.mapDispatchToProps,
)(ContainedIconButton)
